module.exports = __webpack_public_path__ + "static/media/all-are-done-vector.1538bfbc.svg";